/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { LaunchUrlCommand } from './launch-url.command';
import { WindowRefService } from '../../../../core/ui/services/windowRef.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export function launchUrlFactory() {
    const command = new LaunchUrlCommand();
    command.setDependencies({
        windowRef: inject(WindowRefService),
        iconRegistry: inject(MatIconRegistry),
        sanitizer: inject(DomSanitizer),
    });
    return command;
}
